import React, { useEffect, useState } from 'react';
import { ForgotPassword } from '@milkmoovement/common_cognito_package';
import { useHistory } from 'react-router-dom';
import { getRegion } from '../../../../utils';
import { fetchRegionFromBackend } from '../../../../utils/regionConfig';

const ForgotPasswordPage = () => {
    const [region, setRegion] = useState(null);
    const [isLoadingRegion, setIsLoadingRegion] = useState(true);
    const subdomain = window.location.href.split('#')[0];
    const history = useHistory();

    // Fetch region from backend on component mount
    useEffect(() => {
        const loadRegion = async () => {
            try {
                const fetchedRegion = await fetchRegionFromBackend();
                setRegion(fetchedRegion);
            } catch (error) {
                setRegion(getRegion(window.location.hostname));
            } finally {
                setIsLoadingRegion(false);
            }
        };
        loadRegion();
    }, []);

    const handleNavigateBack = () => history.push({ pathname: '/login' });

    // Show loading state while fetching region
    if (isLoadingRegion || !region) {
        return (
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
                <div>Loading...</div>
            </div>
        );
    }

    return <ForgotPassword onNavigateBack={handleNavigateBack} metadata={{ coreSystem: region, clientUrl: `${subdomain}#` }} />;
};

export default ForgotPasswordPage;
